import type { YarnType } from '@/types/yarn-types'

export type Product = {
  finishedWeight: any
  id?: string
  finishedReference?: string
  alternateReference?: string
  displayedReference?: string
  unfinishedReference?: string
  colour?: string
  finish?: string
  fabricWidthValue?: number
  fabricWidthUnit?: number
  fabricYieldValue?: number
  fabricYieldUnit?: number
  averageRollLengthValue?: number
  averageRollLengthUnit?: number
  construction?: string
  fibreContent?: string
  fabricWeight?: number
  standardBatchSize?: number
  fabricStatus: FabricStatusEnum
  guage?: string
  isArchived?: boolean
  merges: ProductMerge[]
  productCosts: any[]
  yarnsUsed: YarnUsed[]
  stitchLengths?: StitchLength[]
  yarnSetOuts: YarnSetOut[]
  knittingSetOuts?: KnittingSetOut[]
}

export enum FabricStatusEnum {
  Finished = 0,
  Unfinished = 1
}

export type ProductMerge = {
  id: string
  mergeNumber: string
  yarnType: YarnType
  yarnColour: string
  yarnCount: number
}

export type YarnUsed = {
  id?: string
  productSpecificationId: string
  yarnCount: string
  yarnColour: string
  yarnType: YarnType
  percentageComposition: number
  feeders: number
}

export type StitchLength = {
  id?: string,
  reference: string,
  lengthValue: number,
  lengthUnit: number,
  numberOfNeedles: number,
  numberOfMachineRevs: number
}

export type Weight = {
  relaxedWidth: number
  weightPerSqMeter: number
  courses: number
  wales: number
}

export type YarnSetOut = {
  id?: string
  cottonFeeder: string
  woolFeeder: string
  cottonColor: string
  woolColor: string
  fabricWeight: Weight
  finishedWeight: Weight
}

export type KnittingSetOut = {
  id?: string
  feeder: number
  dialNeedlesBack: number
  dialNeedlesFront: number
  cylinderNeedlesTop1: number
  cylinderNeedlesTop2: number
  cylinderNeedlesTop3: number
  cylinderNeedlesBottom4: number
}

export type ArchivedProductSpecification = {
  id: string
  finishedReference: string
  unfinishedReference: string
  alternateReference: string
  displayedReference: string
  colour: string
  finish: string
  fabricWidthValue: number
  fabricWidthUnit: number
  fabricYieldValue: number
  fabricYieldUnit: number
  averageRollLengthValue: number
  averageRollLengthUnit: number
  construction: string
  fabricWeight: number
  fibreContent: string
  fabricStatus: FabricStatusEnum
  guage: string
  standardBatchSize: number
  isArchived: boolean
}
